module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_7042.c9a030f4.png";